// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{display:block}:host(.inline){display:inline-block}.uap-bordered-section{border:1.5px solid var(--uap-border-color-gray, #e4e4e4);border-radius:var(--uap-border-radius, 10px);padding:var(--uap-box-padding, 20px);margin-bottom:var(--uap-box-padding, 20px);background:var(--uap-background-color-light, #fafbfc)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
